/**
 * Kachelstil der Standardbilder (`Symbolkachel`) — Betreiber 2026-10-12.
 *
 * Heisst bewusst NICHT „Symbolstil": den Namen traegt schon der Stil der
 * Dateisymbole (`ui/file-icons/stile.ts`, Keks `janeway-symbolstil`). Zwei
 * Einstellungen unter einem Namen waeren zwei Wahrheiten, die sich gegenseitig
 * ueberschreiben.
 *
 * Wirkt NUR auf Standardbilder. Ein echtes Logo sieht in allen drei Stilen
 * gleich aus (weisse Kachel, Originalfarben — siehe `Markenkachel`).
 */
export const KACHEL_STILE = ["schlicht", "farbig", "kraeftig"] as const;

export type KachelStil = (typeof KACHEL_STILE)[number];

/** Vorgabe des Betreibers: getoente Flaeche je Art, Symbol in der Artfarbe. */
export const KACHEL_STIL_VORGABE: KachelStil = "farbig";

export function istKachelStil(wert: unknown): wert is KachelStil {
  return typeof wert === "string" && (KACHEL_STILE as readonly string[]).includes(wert);
}

export const KACHEL_STIL_NAMEN: Record<KachelStil, string> = {
  schlicht: "Schlicht",
  farbig: "Farbig",
  kraeftig: "Kräftig",
};

/**
 * Klasse am `<html>`. Der Stil haengt als KLASSE am Dokument und nicht als
 * Wert im React-Baum: `htmlClassName` aus `resolveInitialTheme` reicht jede
 * App schon heute an `<html>` durch (29 von 29 Layouts, 2026-10-12) — so steht
 * der Stil im ersten Bild, ohne dass ein einziges App-Layout eine neue Prop
 * mitnehmen muss. Die Vorgabe traegt keine Klasse; `globals.css` faerbt sie
 * ohne Bedingung.
 */
export function kachelStilKlasse(stil: KachelStil): string {
  if (stil === "schlicht") return "jw-kacheln-schlicht";
  if (stil === "kraeftig") return "jw-kacheln-kraeftig";
  return "";
}

/** Setzt die Klasse am Dokument — genau eine der beiden, oder keine. */
export function kachelStilAnwenden(wurzel: HTMLElement, stil: KachelStil): void {
  wurzel.classList.toggle("jw-kacheln-schlicht", stil === "schlicht");
  wurzel.classList.toggle("jw-kacheln-kraeftig", stil === "kraeftig");
}
